import React from 'react';

import { Box, useTheme } from '@mui/material';
import './index.scss';

interface DroneLoadingProp {
  /**
   * loading模式：normal、simple、circular、refresh, gradients
   */
  mode?: string;
  /**
   * 模式为：normal时，可配置一张图片
   */
  icon?: string;
  /**
   * loading文本
   */
  text?: string;
}

const DroneLoading = (props: DroneLoadingProp) => {
  const { text = 'loading...' } = props;

  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;

  return (
    <div className="drone-loading__refresh">
      <div
        className="drone-loading__refresh__cont"
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          marginLeft: '-25px',
          marginTop: '-30px',
        }}
      >
        <Box
          className="drone-loading__refresh__gif"
          sx={{
            borderTopColor: primaryColor || '#8251ec',
            borderLeftColor: primaryColor || '#8251ec',
            borderRightColor: primaryColor || '#8251ec',
          }}
        ></Box>
        <p className="drone-loading__refresh__font">{text}</p>
      </div>
    </div>
  );
};

export default DroneLoading;
